module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.7a01b213.svg";